import './ShowMoreTypeLabel.scss';

import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { getSonarObjectTypeAndSourceLabelPlural } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';

type RequireAtLeastOne<T, Keys extends keyof T = keyof T> =
    Pick<T, Exclude<keyof T, Keys>>
    & {
        [K in Keys]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<Keys, K>>>
    }[Keys];

export type ShowMoreTypeLabelProps = RequireAtLeastOne<{label: string, sonarObjectType: SonarObjectType}> & {
	allowShowMore?: boolean;
	onClick: (info: SonarObjectType | string) => void;
};

export const ShowMoreTypeLabel: React.FC<ShowMoreTypeLabelProps> = ({
	allowShowMore,
	label,
	onClick,
	sonarObjectType
}) =>
	<div
		className='data-dictionary-label'
		key={ sonarObjectType }>
		<span>{ sonarObjectType ? getSonarObjectTypeAndSourceLabelPlural(sonarObjectType) : label }</span>
		{ allowShowMore &&
			<span
				className='show-more-link'
				onClick={ () => onClick(sonarObjectType || label) }>
				{ COPY_GENERIC.SHOW_MORE }
			</span> }
	</div>;

